<template>
  <div class="doctorInfo-box">
    <van-cell v-for="item in list" :key="item.id">
      <img slot="icon" class="doctor-img" src="../assets/images/doctor.png">
      <div slot="title" class="doctor-info">
        <div class="doctor-name">{{ item.doctorName }}</div>
        <div class="keep-box">
          <div v-if="item.keepNumbers">余号: {{ item.keepNumbers }} / {{ item.keepTotalNumbers }}</div>
          <div v-else>今日预约已满</div>
          <div>￥{{ item.price }}</div>
        </div>
        <div class="info-box">
          <div class="doctor-hint">{{ item.titleName }}</div>
          <div class="noonAllDay-list">
            <div v-for="noon in item.noonAllDay" :key="noon.noon" class="noonAllDay" @click="doctorClick(item, noon.noon)">{{ `挂${noon.noonName}` }}</div>
          </div>
        </div>
        <DeptTips :item="item" :select-time="selectTime" />
      </div>
    </van-cell>
  </div>
</template>

<script>
import DeptTips from './DeptTips'
export default {
  name: 'DoctorInfo',
  components: {
    DeptTips
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    selectTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    doctorClick(item, noon) {
      this.$emit('doctorClick', item, noon)
    }
  }
}
</script>

<style scoped lang="less">
  .doctor-img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }

  .info-box {
    display: flex;
  }

  .noonAllDay-list {
    display: flex;
    flex: 1;
    justify-content: flex-end;

    .noonAllDay {
      font-size: 15px;
      color: #fff;
      background-color: #00a6ff;
      border-radius: 5px;
      padding: 0 10px;
      margin-right: 15px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  .doctor-hint {
    color: #989898;

    >span {
      margin-left: 5px;
    }
  }

  .keep-box {
    position: absolute;
    top: 5px;
    right: 15px;
    display: flex;
    justify-content: end;
    align-items: center;
    color: #fca237;

    >div {
      &:first-of-type {
        margin-right: 10px;
      }
    }
  }
</style>
